import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminExerciseListPage } from 'pages/admin-exercise-list/admin-exercise-list';

@NgModule({
    declarations: [AdminExerciseListPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdminExerciseListPage]
})
export class AdminExerciseListPageModule {}
